import { useState } from "react";

const SetShowSideBar = () => {
  const [showSideBar, setShowSideBar] = useState(false);
  const [effect, setEffect] = useState(false);

  const onSetShowSideBar = (show: boolean) => {
    setShowSideBar(show);
  };

  /*
   * Hook to close the sidebar whenever there's a mousedown event
   */
  // useEffect(() => {
  //   const handler = () => {
  //     setShowSideBar(false);
  //   };
  //   document.addEventListener("mousedown", handler);

  //   return () => {
  //     document.removeEventListener("mousedown", handler);
  //   };
  // });

  /*
   * Sets the effect of the menu button
   */
  const onSetButtonEffect = (value: boolean) => {
    setEffect(value);
    return effect;
  };

  return { showSideBar, onSetShowSideBar, onSetButtonEffect, effect };
};

export default SetShowSideBar;
